module.exports = __webpack_public_path__ + "images/spy-graphic-73b2be01b704edcd7fdde5e31051124e.png";